// Basic
import { useState } from 'react';
// Components
import Page from '@/common-utils/components/structure/page/Page';
import RemoteCollectionsTable from '@/app/modules/remoteCollections/components/tables/RemoteCollectionsTable';
// Common
import RouteUrls from '../enums/RouteUrls';
import RenderInternationalizedAmount from '@/common-utils/components/renders/currency/RenderInternationalizedAmount';
import remoteCollectionFields from '@/app/modules/remoteCollections/fields/remoteCollectionFields';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';

/**
 * @returns {JSX} RemoteCollections
 */
function RemoteCollections() {

    // State
    const [totalRevenue, setTotalRevenue] = useState();
    const [isRemoteCollectionEmpty, setIsRemoteCollectionEmpty] = useState(false);

    return (
        <Page>
            <Page.Header
                route={RouteUrls.REMOTE_COLLECTION}
                routeBase={RouteUrls.REMOTE_COLLECTION}
            />
            <Page.Body data-cy='page-remote-collections'>
                <RemoteCollectionsTable
                    filtersEventName={setFiltersEventName('remote_collections')}
                    setTotalRevenue={setTotalRevenue}
                    setIsRemoteCollectionEmpty={setIsRemoteCollectionEmpty}
                    pageActions={
                        <div className='flex items-center'>
                            {totalRevenue &&
                                <RenderInternationalizedAmount
                                    amount={totalRevenue[remoteCollectionFields.TOTAL_REVENUE.key]}
                                    currency={totalRevenue[remoteCollectionFields.CURRENCY.key] ?? 'EUR'}
                                    namespace={remoteCollectionFields.TOTAL_REVENUE.namespace}
                                    additionalText={remoteCollectionFields.TOTAL_REVENUE.entity}
                                    isRemoteCollectionEmpty={isRemoteCollectionEmpty}
                                    spanClassName='px-1 h-8 rounded-lg shadow-md border content-center'
                                />
                            }
                        </div>
                    } />
            </Page.Body>
        </Page>
    );
}

export default RemoteCollections;